"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveDashboardModalDashboardName = exports.moveDashboardModalDashboardId = exports.moveDashboardModalFolderName = exports.moveDashboardModalFolderId = exports.moveDashboardModalVisibleState = void 0;
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const dashboard_1 = require("../../../server/models/dashboard");
const folder_1 = require("../../../server/models/folder");
const MoveToFolderModal_1 = __importDefault(require("./MoveToFolderModal"));
const react_router_dom_1 = require("react-router-dom");
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
exports.moveDashboardModalVisibleState = (0, recoil_1.atom)({
    key: 'moveDashboardModalVisibleState',
    default: false,
});
exports.moveDashboardModalFolderId = (0, recoil_1.atom)({
    key: 'moveDashboardModalFolderId',
    default: -1,
});
exports.moveDashboardModalFolderName = (0, recoil_1.atom)({
    key: 'moveDashboardModalFolderName',
    default: '',
});
exports.moveDashboardModalDashboardId = (0, recoil_1.atom)({
    key: 'moveDashboardModalDashboardId',
    default: '',
});
exports.moveDashboardModalDashboardName = (0, recoil_1.atom)({
    key: 'moveDashboardModalDashboardName',
    default: '',
});
const MoveDashboardModal = ({ t }) => {
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.moveDashboardModalVisibleState);
    const [dashboardId] = (0, recoil_1.useRecoilState)(exports.moveDashboardModalDashboardId);
    const [folderId] = (0, recoil_1.useRecoilState)(exports.moveDashboardModalFolderId);
    const [folderName] = (0, recoil_1.useRecoilState)(exports.moveDashboardModalFolderName);
    const [dashboardName] = (0, recoil_1.useRecoilState)(exports.moveDashboardModalDashboardName);
    const history = (0, react_router_dom_1.useHistory)();
    const nullCheck = localStorage.getItem('group_space_id') || '0';
    const moveToFolderModalProps = {
        currentFolderId: folderId,
        currentFolderName: folderId === parseInt(nullCheck)
            ? `${localStorage.getItem('organization_name')}'s ${t('folder')}`
            : folderName,
        dashboardName: dashboardName,
        formSubmitCallback: async (folderId) => await (0, dashboard_1.moveDashboard)(dashboardId, String(folderId), dashboardName),
        successMessage: t('dashboardMoveSuccess'),
        successCallback: () => {
            (0, RedirectTo_1.default)({ history, path: window.location.pathname });
        },
        failureMessage: t('dashboardMoveFail'),
        errorMessage: t('dashboardMoveError'),
        titleName: 'moveDashboardTitle',
        titleValidationCallback: async () => await (0, folder_1.verifyDashboardNameUniqueIn)(dashboardName, folderId.toString()),
        notificationMessage: t('dashboardMoveNotify'),
        duplicateErrorMessage: t('dashboardMoveDuplicate'),
        autoFocus: true,
        headerText: t('dashboardMoveHeader'),
        primaryButtonText: t('dashboardMoveButton'),
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
    };
    return react_1.default.createElement(MoveToFolderModal_1.default, { ...moveToFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(MoveDashboardModal);
